<div class="layout-footer">
    Desarrollado por
    <a href="https://itsoft.mx" target="_blank" rel="noopener noreferrer"
        class="text-primary font-bold hover:underline">ITSoft</a>
</div>
